import src from "IMAGE";
export default { src, width: 1719, height: 409, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAARUlEQVR42gWAMQqAIBRAPXzU6pZUe0VYo3SqQsWvf3liRAq1CqqKlMRzXzg3471nnAZMa5Uv/uSciTHxhsC2Lpz7gbWWDjXeNf+GugqUAAAAAElFTkSuQmCC"};
